// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/MessageText/MessageText.less
// module id = 827
// module chunks = 0